import { render, staticRenderFns } from "./VnoOpenCard.vue?vue&type=template&id=5dd34869&scoped=true&"
import script from "./VnoOpenCard.vue?vue&type=script&lang=js&"
export * from "./VnoOpenCard.vue?vue&type=script&lang=js&"
import style0 from "./VnoOpenCard.vue?vue&type=style&index=0&id=5dd34869&scoped=true&lang=scss&"
import style1 from "./VnoOpenCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd34869",
  null
  
)

export default component.exports